var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReassign(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89 9.946A3.198 3.198 0 016.6 11a3.198 3.198 0 01-2.29-1.054A3.528 3.528 0 013.4 7.5c-.017-.91.31-1.79.91-2.446A3.198 3.198 0 016.6 4c.867.019 1.69.398 2.29 1.054.6.657.928 1.536.91 2.446.018.91-.31 1.79-.91 2.446zm-.467 1.928h.417c.91.02 1.774.42 2.404 1.109.63.689.974 1.612.956 2.567v1.138c.007.34-.116.67-.341.917A1.2 1.2 0 0111 18H2.2a1.2 1.2 0 01-.858-.395 1.323 1.323 0 01-.341-.917V15.55a3.705 3.705 0 01.955-2.568 3.359 3.359 0 012.405-1.107h.417a4.054 4.054 0 001.823.437c.63 0 1.253-.15 1.822-.438zm9.41-1.788a.592.592 0 010 .826l.001.002-2.857 2.915a.564.564 0 01-.809 0 .593.593 0 010-.825l1.88-1.92h-5.476A.577.577 0 0110 10.5c0-.322.255-.583.572-.583h5.478l-1.884-1.92a.592.592 0 010-.826.564.564 0 01.81 0l2.857 2.915z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReassign);
export default ForwardRef;